export async function PacienteAdminCreate(
  firstName,
  lastName,
  sexoPacie,
  direccion,
  direccionNum,
  direccionPiso,
  direccionCiudad,
  direccionProvincia,
  direccionCp,
  email,
  telefono,
  dni,
  nacimiento,
  hce,
  nombreFamiliar,
  telefonoFamiliar,
  estadoUsuario,
  username,
  password
) {
  console.log(
    firstName,
    lastName,
    sexoPacie,
    direccion,
    direccionNum,
    direccionPiso,
    direccionCiudad,
    direccionProvincia,
    direccionCp,
    email,
    telefono,
    dni,
    nacimiento,
    hce,
    nombreFamiliar,
    telefonoFamiliar,
    estadoUsuario,
    username,
    password
  );
  const formData = {
    username: email,
    email: email,
    password: password,
    first_name: firstName,
    last_name: lastName,
    // roles: ['contributor'],
    roles: ["subscriber"],
    meta: {
      dni: dni,
      nacimiento: nacimiento,
      telefono: telefono,
      hce: hce,
      sexo_paciente: sexoPacie,
      direccion: direccion,
      direccion_num: direccionNum,
      direccion_piso: direccionPiso,
      direccion_ciudad: direccionCiudad,
      direccion_provincia: direccionProvincia,
      direccion_cp: direccionCp,
      nombre_familiar: nombreFamiliar,
      telefono_familiar: telefonoFamiliar,
      estado: estadoUsuario,
    },
  };

  const authToken = sessionStorage.getItem("token");

  try {
    const response = await fetch(
      "https://app.tavad.com/hce/wp-json/wp/v2/users",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(formData),
      }
    );
    const values = await response.json();
    console.log(values);
    return values;
  } catch (error) {
    console.error(error);
  }
}
